/**
 * Text roles shared by the side drawers (NO-660). Colors stay on the role
 * tokens that pass AA: meta text is `text-muted-foreground` (sand-500), never
 * `text-subtle` (sand-400).
 */
export const DRAWER_TEXT = {
  title:
    "font-sans text-title-sm leading-[22px] font-bold tracking-[-0.01em] text-foreground",
  readerDate:
    "font-sans text-base leading-6 font-semibold tracking-[-0.01em] text-foreground",
  timelineDate: "font-sans text-base leading-6 font-semibold text-foreground",
  recapTitle: "font-sans text-xl leading-7 font-bold text-foreground",
  sectionHeading:
    "font-sans text-[18px] leading-[26px] font-bold tracking-[-0.01em] text-foreground",
  subheading: "font-sans text-[15.5px] leading-[22px] font-semibold text-foreground",
  body: "text-title-sm leading-6 text-foreground",
  quote: "text-title-sm leading-6 text-muted-strong",
  preview: "text-sm leading-[21px] text-muted-strong",
  meta: "text-body-sm leading-[18px] text-muted-foreground",
  count: "text-body-sm leading-[18px] font-medium text-muted-strong",
  control: "text-body-sm leading-4 font-medium text-foreground",
  stateTitle: "font-sans text-title-sm leading-[22px] font-bold text-foreground",
  stateBody: "text-sm leading-[21px] text-muted-strong",
} as const;

/** Spacing between note blocks, by what precedes them (frames F.3, R.4). */
export const NOTE_BLOCK = {
  sectionHeading: "mt-9 first:mt-4",
  subheading: "mt-5 first:mt-3",
  paragraph: "mt-3 [h3+&]:mt-1.5",
  groupLabelAfterList:
    "[ol+&:has(+ol)]:mt-4 [ol+&:has(+ul)]:mt-4 [ul+&:has(+ol)]:mt-4 [ul+&:has(+ul)]:mt-4",
  groupLabel: "[&:has(+ol)]:font-medium [&:has(+ul)]:font-medium",
  list: "mt-3 pl-6 marker:text-muted-foreground [h3+&]:mt-1.5 [p+&]:mt-1",
  listItems: "space-y-1.5",
  // The quote rule is decorative: classic border-strong, under the always
  // theme the light line-2 rather than the 52% plum of editable edges (NO-799).
  quote:
    "mt-3 flex flex-col gap-1 border-l-2 border-(color:--border-decorative,var(--border-strong)) py-0.5 pl-3 [h3+&]:mt-1.5",
} as const;
